import GuestGlimpse from 'components/glimpses/guest_glimpse/'
import SendAmount from 'components/glimpses/send_glimpse/send_amount/'
import SendNote from 'components/glimpses/send_glimpse/send_note/index'
import { sendEnsightenEvent } from 'lib/ensighten_analytics'

import {
  trackEnter,
  trackChange,
  addGlimpselessRouteToHistory,
} from 'lib/glimpse'
import { assertInitialStep, assignActionToRouterParams } from 'lib/route_utils'

const INITIAL_SEND_STEP = 'amount'

export default (store, history) => ({
  path: 'guest',
  getComponent(nextState, callback) {
    return callback(null, { glimpse: GuestGlimpse })
  },
  onEnter(nextState, replace) {
    trackEnter('guest', nextState, replace)
    assertInitialStep('guest', INITIAL_SEND_STEP, nextState, replace)
  },
  onChange(prevState, nextState, replace) {
    assignActionToRouterParams(nextState)
    trackChange('guest', prevState, nextState, replace)
  },
  childRoutes: [
    {
      path: INITIAL_SEND_STEP,
      component: SendAmount,
      onEnter(nextState, replace) {
        if (
          !nextState.location.state.initial &&
          nextState.location.action !== 'POP' &&
          !nextState.params.prevStep
        ) {
          sendEnsightenEvent('MoneyPoolSendStart')
        }
        addGlimpselessRouteToHistory('guest', nextState, replace, history)
      },
    },
    { path: 'note', component: SendNote },
  ],
})
